import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

interface SummaryModalProps {
  isOpen: boolean;
  onClose: () => void;
  summaryData: any;
  selectedCase: any;
}

export const SummaryModal = ({ isOpen, onClose, summaryData, selectedCase }: SummaryModalProps) => {
  if (!summaryData) return null;

  const sections = [
    { key: 'hechos_caso', title: 'Hechos del Caso', content: summaryData.hechos_caso },
    { key: 'fundamentos_sentencia_apelada', title: 'Fundamentos de la Sentencia Apelada', content: summaryData.fundamentos_sentencia_apelada },
    { key: 'argumentos_parte_recurrente', title: 'Argumentos de la Parte Recurrente', content: summaryData.argumentos_parte_recurrente },
    { key: 'argumentos_contraparte', title: 'Argumentos de la Contraparte', content: summaryData.argumentos_contraparte },
    { key: 'decision_camara', title: 'Decisión de la Cámara', content: summaryData.decision_camara },
    { key: 'argumentos_camara', title: 'Argumentos de la Cámara', content: summaryData.argumentos_camara },
    { key: 'votos_concurrentes', title: 'Votos Concurrentes', content: summaryData.votos_concurrentes },
    { key: 'disidencias', title: 'Disidencias', content: summaryData.disidencias },
  ];

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">
            Resumen del Caso
          </DialogTitle>
          {selectedCase && (
            <div className="text-sm text-muted-foreground space-y-1">
              {selectedCase.carátula && <p><strong>Carátula:</strong> {selectedCase.carátula}</p>}
              {selectedCase.fecha && <p><strong>Fecha:</strong> {selectedCase.fecha}</p>}
              {selectedCase.tribunal && <p><strong>Tribunal:</strong> {selectedCase.tribunal}</p>}
            </div>
          )}
        </DialogHeader>
        
        <div className="space-y-6 mt-6">
          {sections.map((section) => (
            section.content && (
              <Card key={section.key}>
                <CardHeader>
                  <CardTitle className="text-lg">{section.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm leading-relaxed whitespace-pre-wrap">
                    {section.content}
                  </p>
                </CardContent>
              </Card>
            )
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};